import React from 'react'

interface JsonDiffProps {
  left: any
  right?: any
  delta: any
  type?: string
}

export const JsonDiff: React.FC<JsonDiffProps> = (props) => {
  const { left, delta } = props

  try {
    // Use require to dynamically load the formatter to bypass TypeScript module resolution issues
    const htmlFormatter = require('jsondiffpatch/formatters/html')
    const html = htmlFormatter.format(delta, left)
    
    if (htmlFormatter.hideUnchanged) {
      htmlFormatter.hideUnchanged()
    }

    return html ? (
      <div dangerouslySetInnerHTML={{ __html: html }} />
    ) : (
      <p>Both objects are identical.</p>
    )
  } catch (error) {
    console.error('JsonDiff error:', error)
    return <p>Both objects are identical.</p>
  }
}
